import { render } from "./damage-display.vue?vue&type=template&id=181f36f6"
import script from "./damage-display.vue?vue&type=script&lang=js"
export * from "./damage-display.vue?vue&type=script&lang=js"
script.render = render

export default script